import { AuthContext } from "@via/context/auth-context.tsx";
import { useContext } from "react";
export function useAuth(): any {
  return useContext(AuthContext);
}
